import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withState from 'recompose/withState';
import propEq from 'ramda/es/propEq';
import find from 'ramda/es/find';
import { withTranslation } from 'react-i18next';

import withToggle from 'app/common/containers/withToggle';
import { subPrepayd } from 'app/actions/apps/subs/prepayd';


export default compose(
  withToggle(),
  withState('months', 'setMonths', null),
  withState('comment', 'setComment', ''),

  withTranslation('tariff'),

  connect(
    state => ({
      submitting: state.apps.opts.paying,
    }),
    (dispatch, {
      months,
      setMonths,
      setComment,
      periods,
      subId,
      handleToggle,
      isSms,
      externalToggle,
      t,
    }) => ({
      handleCheck: (e) => {
        const { name, checked } = e.currentTarget;
        if (checked) {
          const number = parseInt(name, 10);
          setMonths(number);
          const hasNumber = propEq('months_number', number);
          const period = find(hasNumber, periods);
          setComment(
            (period.title && period.cost)
              ? t('buy_subscribe_confirm_with_cost', { title: period.title, cost: '{inject_price}' })
              : t('buy_subscribe_confirm')
          );
        }
      },
      handleSubmit: async (e) => {
        e.preventDefault();
        const res = await dispatch(subPrepayd(subId, months, isSms));
        if (res) {
          if (externalToggle) {
            externalToggle();
            return;
          }
          handleToggle();
        }
      },
    })
  )

);
